import React from 'react';
import additional from './additional_color.svg'

const Additional_color = ({ isMobile }) => {
  return (
    <img width={isMobile ? "36" : "56"} height={isMobile ? "36" : "56"} src={additional} />
  )
};

export default Additional_color;
